import { ACTIVITY_FORMS_NUMBERS } from 'pages/create-activity/constants';

export const addMandatoryFeesLanguage = (
  forms,
  newLanguage,
  changeFormFieldValue,
  updateFormErrors,
  setSavedForms,
  savedForms
) => {
  let mandatoryFees = [...forms.mandatoryFeesForm.values.mandatoryFees];
  mandatoryFees = mandatoryFees.map(item => {
    if (!item[newLanguage]) {
      return {
        ...item,
        [newLanguage]: {
          title: '',
          description: '',
          USD: '0',
          EUR: '0',
          NOK: '0'
        }
      };
    }
    return item;
  });
  changeFormFieldValue('mandatoryFeesForm', 'mandatoryFees', mandatoryFees);
  if (forms['mandatoryFeesForm'].values.mandatoryFees.length) {
    updateFormErrors('mandatoryFeesForm', {
      init: 'Error'
    });
    setSavedForms({
      ...savedForms,
      mandatoryFeesForm: {
        mandatoryFees: mandatoryFees
      }
    });
  }
};

export const deleteMandatoryFeesLanguage = (
  forms,
  deletedLanguage,
  changeFormFieldValue,
  activeTab,
  setActiveTab,
  setSavedForms,
  savedForms,
  updateFormErrors,
  submitForm
) => {
  let mandatoryFees = [...forms.mandatoryFees.values.mandatoryFees];
  mandatoryFees = mandatoryFees.map(item => {
    return {
      ...item,
      [deletedLanguage]: null
    };
  });
  changeFormFieldValue('mandatoryFees', 'mandatoryFees', mandatoryFees);
  if (forms['mandatoryFees'].values.mandatoryFees.length) {
    if (activeTab === ACTIVITY_FORMS_NUMBERS.mandatoryFeesForm) {
      setActiveTab(activeTab);
    }
    setSavedForms({
      ...savedForms,
      mandatoryFeesForm: {
        mandatoryFees: mandatoryFees
      }
    });
    submitForm('mandatoryFeesForm');
  }
};
